import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Format, Lookup, Pager, Paging, Popup } from "devextreme-react/data-grid";
import { GroupItem, Item } from "devextreme-react/form";
import { dataGridErrorHandling, showError } from '../../utils/errorHandling';
import { useAssistitiContattiDataSource } from '../../datasources/AssistitiContattiDataSource';
import { useTipiContattiDataSource } from '../../datasources/TipiContattiDataSource';
import { RenderCellTelphone } from '../../utils/dataGridUtilities';

type Props = {
  assistitoId: string;
  onchanged?: () => void;
  readOnly?: boolean;
}

export type AssistitoEdiContattiPanelHandle = {
}

const AssistitoEditContattiPanel: React.ForwardRefRenderFunction<AssistitoEdiContattiPanelHandle, Props> = (props, ref) => {
  const dataSource = useAssistitiContattiDataSource(props.assistitoId);
  const gridRef = useRef<DataGridRef>(null);

  return (
    <React.Fragment>
      <DataGrid
        dataSource={dataSource}
        ref={gridRef}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
        onRowInserted={props.onchanged}
        onRowRemoved={props.onchanged}
        onRowUpdated={props.onchanged}
      >
        <Editing
          mode="popup"
          allowUpdating={props.readOnly !== true}
          allowAdding={props.readOnly !== true}
          allowDeleting={props.readOnly !== true}>
          <Popup title="Traumi" showTitle={true} />
          <Form colCount={1}>
            <Item dataField="cognome" editorType='dxTextBox' />
            <Item dataField="nome" editorType='dxTextBox' />
            <Item
              dataField="tipoContattoId"
              editorType="dxSelectBox"
              editorOptions={{
                dataSource: useTipiContattiDataSource(),  
                displayExpr: 'descrizione',        
                valueExpr: 'id',            
                placeholder: 'Seleziona un tipo di contatto', 
              }}
            />
            <Item dataField="email" editorType='dxTextBox'/>
            <Item dataField="telefono" editorType='dxTextBox'/>
            <Item dataField="cellulare" editorType='dxTextBox'/>
            <Item dataField="note" editorType='dxTextArea'/>
          </Form>
        </Editing>
        <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
        <Column dataField={'cognome'} caption={'Cognome'} />
        <Column dataField={'nome'} caption={'Nome'} />
        <Column dataField={'tipoContattoId'} visible={false} />
        <Column dataField={'tipoContatto'} caption={'TipoContatto'} />
        <Column dataField={'email'} caption={'Email'} />
        <Column dataField={'telefono'} caption={'Telefono'} cellRender={RenderCellTelphone} />
        <Column dataField={'cellulare'} caption={'Cellulare'} cellRender={RenderCellTelphone} />
        <Column dataField={'note'} caption={'Note'} />
        </DataGrid>
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditContattiPanel);